/* eslint-disable max-len */
import { organizationusersList } from "./apiSlice";

const alertsList = organizationusersList.injectEndpoints({
    tagTypes: ['Alerts',],
    endpoints: (builder) => ({
        getAlerts: builder.query({
            query: (searchParams) => `patients/list-recieved-provider-alert?${searchParams}`,
            providesTags: (result = [], error, arg) => error === undefined ? [
                'Alerts',
                ...result?.data !== undefined && Array.isArray(result?.data) && result?.data?.map(({ _id }) => ({ type: 'Alerts', id: _id }))
            ] : []
        }),

        acknowledgeAlert: builder.mutation({
            query: (id) => ({
                url: `patients/acknowledge-alert/${id}`,
                method: 'PATCH',
                body: {
                    "status": "Acknowledged"
                }
            }),
            invalidatesTags: (result, error, arg) => [{ type: 'Alerts', id: arg.id }]
        }),
        wellnessDropdownGetData: builder.query({
            query: (searchParams) => ({
                url: `patients/alerts-dropdown${searchParams}`,
                method: 'GET',
               
            }),
        }),
        getWellnessNotesList: builder.query({
            query: (searchParams) => ({
                url: `patients/list-all-wellness-notes?${searchParams}`,
                method: 'GET',
               
            }),
        }),
        exportWellnessNotesList: builder.mutation({
            query: ({ queryString, columns, dateformat }) => ({
                url: `patients/export-wellness-reports?${queryString}`,
                method: 'POST',
                body: { "columns": columns, "dateformat": dateformat, "timezone": Intl.DateTimeFormat().resolvedOptions().timeZone }
            }),
        }),
        exportDeviceAlertList: builder.mutation({
            query: ({ queryString, columns, dateformat }) => ({
                url: `patients/export-device-alerts?${queryString}`,
                method: 'POST',
                body: { "columns": columns, "dateformat": dateformat, "timezone": Intl.DateTimeFormat().resolvedOptions().timeZone }
            }),
        }),
        exportProviderAlertReportList: builder.mutation({
            query: ({ queryString, columns, dateformat }) => ({
                url: `patients/list-providers-alerts-report/export?${queryString}`,
                method: 'POST',
                body: { "columns": columns, "dateformat": dateformat, "timezone": Intl.DateTimeFormat().resolvedOptions().timeZone }
            }),
        }),
        deviceDetails:builder.query({
            query:(id)=>`/users/${id}`,
            
            providesTags:(result=[],error,arg)=>error===undefined?[
                'device',
                ...result?.data!==undefined&&Array.isArray(result?.data)&&result?.data?.map(({_id})=>({type:'device',id:_id}))
            ]:[],
        }),
        deviceAlertAcknowledge: builder.mutation({
            query: (id) => ({
                url: `patients/alert-acknowledge/${id}?is_acknowledged=true`,
                method: 'POST',
                body: {
                    "status": "Acknowledged"
                }
            }),
            invalidatesTags: (result, error, arg) => [{ type: 'Alerts', id: arg.id }]
        }),
    }),
   
    overrideExisting: false
})


export const {
    useGetAlertsQuery,
    useAcknowledgeAlertMutation,
    useWellnessDropdownGetDataQuery,
    useGetWellnessNotesListQuery,
    useExportWellnessNotesListMutation,
    useExportDeviceAlertListMutation,
    useExportProviderAlertReportListMutation,
    useLazyDeviceDetailsQuery,
    useDeviceAlertAcknowledgeMutation,

} = alertsList